/**
 Author - Muhamed Afsal
 Git - https://bitbucket.org/mohdafsal/
 **/

import fullTimeJobQuestions from "./fulltimeJobQuestions";
import ownBusinessQuestions from "./ownBusinessQuestions";
import freelanceQuestions from "./freelanceQuestions";

const onboardingQuestions = {
  question: "what is your current occupation?",
  description: "this will help us know you better as a wealth partner",
  answerKey: "current_occupation",
  options: [
    fullTimeJobQuestions,
    ownBusinessQuestions,
    freelanceQuestions
  ]
};

export default onboardingQuestions;
